import { Client } from 'urql';
import { suburbPageQuery } from './suburbPageQuery';

export const fetchSuburbPage = async ({ client, slug }: { client: Client; slug: string }) => {
  const { data, error } = await client.query(suburbPageQuery, { slug }).toPromise();
  return { data, error };
};
